import {UserBase, UserExtended} from '@/features/users/types'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {Mail01Icon, Phone01Icon} from '@/components/ui/icon/Icon'
import {RowMenu} from '../row-menu/RowMenu'
import {usePermissions} from '@/features/auth/store/store'

export const UserDetailsOptions = ({user}: {user: UserExtended}) => {
    const permissions = usePermissions()

    return (
        <Flexbox>
            <ButtonLink variant="tertiary" to={`tel:${user.phoneNumber}`}>
                <Phone01Icon />
                {user.phoneNumber}
            </ButtonLink>
            <ButtonLink variant="tertiary" to={`mailto:${user.email}`}>
                <Mail01Icon />
                {user.email}
            </ButtonLink>
            {permissions?.users?.write && (
                <RowMenu isDetails user={{roleName: user.role?.name, ...UserBase.parse(user)}} />
            )}
        </Flexbox>
    )
}
